import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ShieldX } from "lucide-react";
import { APP_NAME, SUPPORT_EMAIL } from "@crewledger/shared/constants";
import { useAuth } from "@/features/auth/auth-provider";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { InfoBanner } from "@/components/design/info-banner";

export function AccessDeniedPage() {
  const { logout } = useAuth();

  useEffect(() => {
    document.title = `Access denied — ${APP_NAME}`;
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/30 p-6">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-lg bg-destructive/10 text-destructive">
            <ShieldX className="h-6 w-6" />
          </div>
          <CardTitle>Access denied</CardTitle>
          <CardDescription>
            Your Werkio access is currently blocked or unavailable.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <InfoBanner variant="warning">
            If you believe this is a mistake, contact{" "}
            <a href={`mailto:${SUPPORT_EMAIL}`} className="font-medium underline">
              {SUPPORT_EMAIL}
            </a>
            .
          </InfoBanner>
          <Button className="w-full" variant="outline" onClick={() => void logout()}>
            Sign out
          </Button>
          <p className="text-center text-sm text-muted-foreground">
            <Link to="/" className="font-medium hover:underline">
              Back to home
            </Link>
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
